import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { BetslipPanel } from '@/betslip';
import type { BetslipPage } from '@/ui/betslip/EmptyBetslip';

export type BetslipSearch = {
  tab?: BetslipPage;
};

/** Mobile-only full-screen betslip; desktop shows it in the shell's aside rail. */
export const Route = createFileRoute('/betslip')({
  validateSearch: (search: Record<string, unknown>): BetslipSearch => ({
    tab: search.tab === 'my-bets' ? 'my-bets' : undefined,
  }),
  component: BetslipPage,
});

function BetslipPage() {
  // Lock document scroll so only the selections list scrolls inside the panel.
  useEffect(() => {
    const html = document.documentElement;
    const prev = {
      htmlOverflow: html.style.overflow,
      htmlOverscroll: html.style.overscrollBehavior,
      bodyOverflow: document.body.style.overflow,
      bodyOverscroll: document.body.style.overscrollBehavior,
    };
    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';
    return () => {
      html.style.overflow = prev.htmlOverflow;
      html.style.overscrollBehavior = prev.htmlOverscroll;
      document.body.style.overflow = prev.bodyOverflow;
      document.body.style.overscrollBehavior = prev.bodyOverscroll;
    };
  }, []);

  return (
    // Pin between MobileHeader (top-14) and MobileBottomNav (bottom-20) on small screens.
    <div className="flex flex-col bg-bg-canvas max-lg:fixed max-lg:inset-x-0 max-lg:top-14 max-lg:bottom-20 max-lg:z-20 max-lg:overflow-hidden max-lg:px-2 max-lg:pt-2 lg:mx-auto lg:w-full lg:max-w-lg">
      <BetslipPanel className="h-full min-h-0 max-lg:flex-1 lg:h-auto lg:flex-none" />
    </div>
  );
}
